import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AnalyzersService } from 'src/app/providers/services/analyzers.service';
import { GatewaysService } from 'src/app/providers/services/gateways.service';
import { SkidsService } from 'src/app/providers/services/skids.service';
import { Gateway } from 'src/app/storage/models/gateway.model';
import { Mission } from 'src/app/storage/models/mission.model';
import { SkidMission } from 'src/app/storage/models/skid-mission.model';

@Component({
    selector: 'app-add-gateway',
    templateUrl: './add-gateway.component.html',
    styleUrls: ['./add-gateway.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddGatewayComponent implements OnInit, OnDestroy {
  flyingGateways: Gateway[];
  missionSkidsGateways: Gateway[];
  missionAnalyzersGateways: Gateway[];

  @Input() mission: Mission;
  @Output() closeModal = new EventEmitter<any>();

  private gatewaysSubscription: Subscription;

  constructor(
    private gatewaysService: GatewaysService,
    private skidsService: SkidsService,
    private analyzersService: AnalyzersService
  ) { }

  ngOnInit(): void {
    this.gatewaysSubscription = this.gatewaysService.gateways$.subscribe((gateways: Gateway[]) => {
      // Get flying gateways
      this.flyingGateways = gateways.filter(gateway => gateway.isFlying);

      // Get mission skids gateways
      const missionSkids = this.skidsService.missionSkids$.getValue();
      this.missionSkidsGateways = missionSkids
        // Find gateways in mission skids
        .reduce((acc: Gateway[], cur) => {
          if (cur.skid.gateway != null) { acc.push(cur.skid.gateway); }
          if (cur.gateway != null) { acc.push(cur.gateway); }
          return acc;
        }, [])
        // Remove duplicates
        .reduce((acc: Gateway[], cur) => {
          return acc.find(gateway => gateway.gatewayId === cur.gatewayId) == null ?
                  [...acc, cur] :
                  acc;
        }, []);

      // Get mission analyzers gateways
      const missionAnalyzers = this.analyzersService.missionAnalyzers$.getValue();
      this.missionAnalyzersGateways = missionAnalyzers
        // Find gateways in mission analyzers
        .reduce((acc: Gateway[], cur) => {
          if (cur.gateway != null) { acc.push(cur.gateway); }
          return acc;
        }, [])
        // Remove duplicates
        .reduce((acc: Gateway[], cur) => {
          return acc.find(gateway => gateway.gatewayId === cur.gatewayId) == null ?
                  [...acc, cur] :
                  acc;
        }, []);
    });
  }

  ngOnDestroy(): void {
    if (this.gatewaysSubscription) { this.gatewaysSubscription.unsubscribe(); }
  }

  close(): void {
    this.closeModal.emit();
  }

  addGateway(gateway: Gateway): void {
    this.closeModal.emit(gateway);
  }

}
